import { connect } from 'react-redux'
import ConfirmForm from './ConfirmForm'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmForm)
